import styled from "@emotion/styled";
import Page from 'components/layout/Page';

const Elem:React.FC<any> = () => {
  return (
    <Page disable={false}>
      <h1>OrderDelivery</h1>
    </Page>
  );
};

export default Elem;